import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import ExpenseServices from '@Services/purchase/expense/expenseServices';
import ExpenseActions, { expenseActionTypes } from '@Actions/purchase/expense/expenseActions';

/**
 * @param action
 */
function* _getExpense(action) {
  const {
    tenantId, expenseId, customerId, sellerId, departmentId, page, limit, status, startDate, endDate, searchKeyword,
  } = action;
  yield put(ExpenseActions.getExpenseLoading(true));
  try {
    const expenses = yield ExpenseServices.getExpense(tenantId, expenseId, customerId, sellerId, departmentId, page, limit, status, startDate, endDate, searchKeyword);
    yield put(ExpenseActions.getExpenseSuccess(expenses));
    yield put(ExpenseActions.getExpenseLoading(false));
  } catch (error) {
    yield put(ExpenseActions.getExpenseLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(expenseActionTypes.GET_EXPENSE.ERROR, error));
  }
}

/**
 *
 */
function* getExpense() {
  yield takeLatest(expenseActionTypes.GET_EXPENSE.REQUEST, _getExpense);
}
/**
 * @param action
 */
function* _createExpense(action) {
  try {
    yield put(ExpenseActions.createExpenseLoading(true));
    const expense = yield ExpenseServices.createExpense(action.payload);
    if (expense.success) {
      yield put(TrackerActions.trackAction(expenseActionTypes.CREATE_EXPENSE.SUCCESS, expense.data));
      notification.open({
        type: 'success',
        message: 'Expense successfully created',
        duration: 4,
        placement: 'top',
      });
      yield put(ExpenseActions.createExpenseLoading(false));
      if (action.callback) {
        action.callback(expense);
      }
    } else {
      notification.open({
        type: 'error',
        message: expense?.error,
        duration: 4,
        placement: 'top',
      });
      yield put(ExpenseActions.createExpenseLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.error,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(expenseActionTypes.CREATE_EXPENSE.ERROR, error));
    yield put(ExpenseActions.createExpenseLoading(false));
  }
}

/**
 *
 */
function* createExpense() {
  yield takeLatest(expenseActionTypes.CREATE_EXPENSE.REQUEST, _createExpense);
}

/**
 *
 * @param {*} action
 */
function* _updateExpense(action) {
  try {
    yield put(ExpenseActions.updateExpenseLoading(true));
    const expense = yield ExpenseServices.updateExpense(action.payload);
    if (expense.success) {
      yield put(TrackerActions.trackAction(expenseActionTypes.UPDATE_EXPENSE.SUCCESS, expense.data));
      notification.open({
        type: 'success',
        message: 'Expense updated successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(ExpenseActions.updateExpenseLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: expense?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(ExpenseActions.updateExpenseLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(expenseActionTypes.UPDATE_EXPENSE.ERROR, error));
    yield put(ExpenseActions.updateExpenseLoading(false));
  }
}

/**
 *
 */
function* updateExpense() {
  yield takeLatest(expenseActionTypes.UPDATE_EXPENSE.REQUEST, _updateExpense);
}

/**
 * @param action
 */
function* _getExpenseById(action) {
  try {
    yield put(ExpenseActions.getExpenseByIdLoading(true));
    const {
      tenantId, expenseId, callback,
    } = action;
    const expenseById = yield ExpenseServices.getExpenseById(tenantId, expenseId);
    yield put(ExpenseActions.getExpenseByIdSuccess(expenseById?.expense?.expenses?.[0]));
    if (callback) {
      action.callback(expenseById);
    }
    yield put(ExpenseActions.getExpenseByIdLoading(false));
  } catch (error) {
    yield put(ExpenseActions.getExpenseByIdLoading(false));
    yield put(TrackerActions.trackAction(expenseActionTypes.GET_EXPENSE_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getExpenseById() {
  yield takeLatest(expenseActionTypes.GET_EXPENSE_BY_ID.REQUEST, _getExpenseById);
}

/**
 * @param action
 */
function* _deleteExpense(action) {
  try {
    yield put(ExpenseActions.deleteExpenseLoading(true));
    const deletedExpense = yield ExpenseServices.deleteExpense(action.payload);
    if (deletedExpense.success) {
      notification.open({
        type: 'success',
        message: 'Expense has been deleted.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: deletedExpense?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ExpenseActions.deleteExpenseLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(expenseActionTypes.DELETE_EXPENSE.ERROR, error));
    yield put(ExpenseActions.deleteExpenseLoading(false));
  }
}

/**
 *
 */
function* deleteExpense() {
  yield takeLatest(expenseActionTypes.DELETE_EXPENSE.REQUEST, _deleteExpense);
}

/**
 * @param action
 */
function* _linkExpense(action) {
  try {
    yield put(ExpenseActions.linkExpenseLoading(true));
    const linkedExpense = yield ExpenseServices.linkExpense(action.payload);
    if (linkedExpense.success) {
      notification.open({
        type: 'success',
        message: 'Expense has been linked.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: linkedExpense?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ExpenseActions.linkExpenseLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(expenseActionTypes.LINK_EXPENSE.ERROR, error));
    yield put(ExpenseActions.linkExpenseLoading(false));
  }
}

/**
 *
 */
function* linkExpense() {
  yield takeLatest(expenseActionTypes.LINK_EXPENSE.REQUEST, _linkExpense);
}

/**
 * @param action
 */
function* _unLinkExpense(action) {
  try {
    yield put(ExpenseActions.unLinkExpenseLoading(true));
    const expense = yield ExpenseServices.unLinkExpense(action.expensePaymentId);
    if (expense?.success) {
      notification.open({
        type: 'success',
        message: 'Unlinked expense Successfully!',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: expense?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ExpenseActions.unLinkExpenseLoading(false));
  } catch (error) {
    yield put(ExpenseActions.unLinkExpenseLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(expenseActionTypes.UNLINK_EXPENSE.ERROR, error));
  }
}

/**
 *
 */
function* unLinkExpense() {
  yield takeLatest(expenseActionTypes.UNLINK_EXPENSE.REQUEST, _unLinkExpense);
}

/**
 * @param action
 */
function* _getAccount(action) {
  const {
    tenantId, page, limit, searchKeyword, callback,
  } = action;
  yield put(ExpenseActions.getAccountLoading(true));
  try {
    const accounts = yield ExpenseServices.getAccount(tenantId, page, limit, searchKeyword);
    yield put(ExpenseActions.getAccountSuccess(accounts));
    yield put(ExpenseActions.getAccountLoading(false));
    if (action.callback) {
      action.callback(accounts);
    }
  } catch (error) {
    yield put(ExpenseActions.getAccountLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(expenseActionTypes.GET_ACCOUNT.ERROR, error));
  }
}

/**
 *
 */
function* getAccount() {
  yield takeLatest(expenseActionTypes.GET_ACCOUNT.REQUEST, _getAccount);
}

/**
 * @param action
 */
function* _createAccount(action) {
  try {
    yield put(ExpenseActions.createAccountLoading(true));
    const account = yield ExpenseServices.createAccount(action.payload);
    if (account.success) {
      yield put(TrackerActions.trackAction(expenseActionTypes.CREATE_EXPENSE.SUCCESS, account.data));
      notification.open({
        type: 'success',
        message: 'Account successfully created',
        duration: 4,
        placement: 'top',
      });
      yield put(ExpenseActions.createAccountLoading(false));
      if (action.callback) {
        action.callback(account.account);
      }
    } else {
      notification.open({
        type: 'error',
        message: account?.error,
        duration: 4,
        placement: 'top',
      });
      yield put(ExpenseActions.createAccountLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(expenseActionTypes.CREATE_ACCOUNT.ERROR, error));
    yield put(ExpenseActions.createAccountLoading(false));
  }
}

/**
 *
 */
function* createAccount() {
  yield takeLatest(expenseActionTypes.CREATE_ACCOUNT.REQUEST, _createAccount);
}

/**
 *
 * @param {*} action
 */
function* _updateAccount(action) {
  try {
    yield put(ExpenseActions.updateAccountLoading(true));
    const expense = yield ExpenseServices.updateAccount(action.payload);
    if (expense.success) {
      yield put(TrackerActions.trackAction(expenseActionTypes.UPDATE_ACCOUNT.SUCCESS, expense.data));
      notification.open({
        type: 'success',
        message: 'Account updated successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(ExpenseActions.updateAccountLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: expense?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(ExpenseActions.updateAccountLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(expenseActionTypes.UPDATE_ACCOUNT.ERROR, error));
    yield put(ExpenseActions.updateAccountLoading(false));
  }
}

/**
 *
 */
function* updateAccount() {
  yield takeLatest(expenseActionTypes.UPDATE_ACCOUNT.REQUEST, _updateAccount);
}

/**
 * @param action
 */
function* _deleteAccount(action) {
  try {
    yield put(ExpenseActions.deleteAccountLoading(true));
    const expense = yield ExpenseServices.deleteAccount(action.payload);
    if (expense?.success) {
      notification.open({
        type: 'success',
        message: 'Account has been deleted.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: expense?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ExpenseActions.deleteAccountLoading(false));
  } catch (error) {
    yield put(ExpenseActions.deleteAccountLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(expenseActionTypes.DELETE_ACCOUNT.ERROR, error));
  }
}

/**
 *
 */
function* deleteAccount() {
  yield takeLatest(expenseActionTypes.DELETE_ACCOUNT.REQUEST, _deleteAccount);
}

/**
 *
 */
export default function* expenseSaga() {
  yield all([
    getExpense(),
    createExpense(),
    updateExpense(),
    getExpenseById(),
    deleteExpense(),
    linkExpense(),
    unLinkExpense(),
    getAccount(),
    createAccount(),
    updateAccount(),
    deleteAccount(),
  ]);
}
